// extracted by mini-css-extract-plugin
export var post = "Post-module--post--9y52F";
export var post__author = "Post-module--post__author--NLzwe";
export var post__category = "Post-module--post__category--+aWWI";
export var post__cover = "Post-module--post__cover--V79zA";
export var post__title = "Post-module--post__title--ZeuHN";